import { makeStyles } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import MessagesContext from '../../../../contexts/messagesContext';
import { useDispatch, useSelector } from 'react-redux';
import { createSearchReport, getSearchReport } from '../../../../redux/Search/SearchAction';
import CreateReport from '../../../Setting/DownloadReports/createReport';
import { useRef } from 'react';
import { PropTypes } from 'prop-types';

const styles = makeStyles({
    header: {
        display: 'flex',
        alignItems: 'center',
        position: 'sticky',
        top: '-60px',
        zIndex: '10',
        background: '#fff',
        height: '60px'
    },
    wrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    dateContainer: {
        marginInlineEnd: '60px',
        position: 'relative'
    },
    exportContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '8px',
        '& > div': {
            minWidth: '135px',
            maxWidth: '250px'
        },
        '& button': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        }
        // '& button svg': {
        //     marginInlineEnd: '6px',
        //     width: '20px',
        //     height: '20px'
        // }
    },
    button: {
        // minWidth: '120px',
        // height: '31px',
        padding: '5px 12px',
        borderRadius: '6px',
        border: '1.5px solid #416ce1',
        backgroundColor: '#fff',
        fontFamily: 'inherit',
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#416ce1',
        // marginInlineStart: '8px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    selectWrapper: {
        position: 'relative',
        minWidth: '260px',
        paddingInlineStart: '12px',
        paddingBottom: '5px',
        marginInlineEnd: 'auto',
        '& > div': {
            width: '100%'
        }
    },
    total: {
        width: '200px',
        height: '33px',
        borderRadius: '4px',
        border: '1px solid #ced2d6',
        marginRight: 'auto',
        display: 'flex',
        justifyContent: 'space-between',
        '& span:first-child': {
            padding: '4px 10px',
            borderInlineEnd: '1.5px solid #ced2d6'
        },
        '& span:last-child': {
            padding: '4px 10px',
            textAlign: 'center',
            width: '100%'
        }
    }
});

const ResultHeader = ({ keys, setDownloadDialog }) => {
    const { messages } = useContext(MessagesContext);
    const classes = styles();
    const total = useSelector((state) => state?.search?.total);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const timer = useRef(null);
    const fields = useSelector((state) => state.search.fields.filter((item) => item.value));
    const selectedValue = fields.filter((item) =>
        item.structure === 'patient' ? item : keys?.find((field) => item?.field?.id === field)
    );
    const reports = useSelector((state) => state?.search?.reports);
    const report = reports?.[0];
    const isDoing = reports?.some((item) => item.export_status === 'D') ?? false;

    const handleCreateFormReport = (value) => {
        const exportConfig = {
            ...value,
            separator: ';',
            flat: value?.flat === 'true' ? true : false
        };
        if (isLoading) {
            return;
        } else {
            setIsLoading(true);
            dispatch(createSearchReport(exportConfig, selectedValue));
        }
    };

    useEffect(() => {
        if (isLoading || isDoing) {
            timer.current = setInterval(async () => {
                const res = await dispatch(getSearchReport());
                if (res?.status >= 200 && res?.status <= 202) {
                    const isGenerated =
                        res?.data?.results?.every((item) => item.export_status === 'G') ?? false;
                    if (isGenerated) {
                        setIsLoading(false);
                    }
                    setDownloadDialog(true);
                }
            }, 10000);
            return () => {
                clearInterval(timer.current);
            };
        }
    }, [isLoading, isDoing]);

    return (
        <>
            <div className={classes.header}>
                <div className={classes.wrapper}>
                    <div className={`${classes.row} ${classes.selectWrapper}`}></div>
                    <div className={classes.exportContainer}>
                        {total ? (
                            <div className={classes.total}>
                                <span>{messages.total} </span>
                                <span>
                                    {total} {messages.patient}
                                </span>
                            </div>
                        ) : null}
                        <CreateReport
                            handleCreateReport={handleCreateFormReport}
                            isLoading={isLoading}
                            isSearch
                            form={report}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
ResultHeader.propTypes = {
    keys: PropTypes.array,
    setDownloadDialog: PropTypes.func
};
export default ResultHeader;
